/**
 * This file is a part of the Promvc framework.
 * 
 * (c) ThemePlexi
 * 
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import { LOGIN_USER_SUCCESS } from '../../constants/index.js';

/**
 * User info reducer.
 * 
 * @param  {Object} state  The initial state.
 * @param  {String} action The action to perform. 
 * @return {Object}
 */
export default function ( state = {}, action )
{
	switch ( action.type )
	{
		case LOGIN_USER_SUCCESS:
			return { ...action.payload.info };

		default:
			return { ...state };
	}
}